import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerSubscription = () => {
  const customerId = useCustomerId()

  return useQuery({
    queryKey: ['customer', customerId, 'subscription'],
    queryFn: () => get(`/customers/${customerId}/subscription_expiry_date`),
  })
}
